import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {OAuthService} from 'angular-oauth2-oidc';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { SarService } from '../service/sar.service';
import { ModalTermsComponent } from '../body-home/modal-terms/modal-terms.component';
import { HomeAllRequestService } from '../service/home-all-request.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent  implements OnInit  {
  email: any;
  name: any;
  lastname: any;
  claims: any;
  names: string;
  nameTool: any;
  side: boolean;
  ActiveModule: any
  // states mobile
  optionMenuMobile = 0;

  selectLang: string;
  navbarMobile =false;

  //modalsTerms
  id: any;
  hasAgreeed: any;



  constructor(public translate: TranslateService,
    private dateAdapter: DateAdapter<Date> ,
    private oauthService: OAuthService,
    public paginator: MatPaginatorIntl,
    private spinner: NgxSpinnerService,
    private dataApiH: HomeAllRequestService,
    public dialog: MatDialog,
    private dataApiSar: SarService ) {
    this.givenName();
    translate.addLangs(['en', 'es']);
    if(sessionStorage.lang === undefined || sessionStorage.lang == null){
      translate.setDefaultLang('en');
      this.selectLang='en';
      this.dateAdapter.setLocale('en');
      sessionStorage.setItem('lang', 'en');
    } else {
      this.selectLang = String(sessionStorage.lang);
      this.dateAdapter.setLocale(sessionStorage.lang);
      this.spinner.show("translate")
      translate.use(String(sessionStorage.lang)).subscribe( (response)=>{this.spinner.hide("translate")}, ()=>{this.spinner.hide("translate")});
    }



    this.side = false;
    this.ActiveModule = {
      admin_rol_list: false,
      admin_types_lists: false,
      admin_business_units: false,
      admin_faq_section: false,
      admin_sites: false,
      admin_i18n_sar: false,
      admin_i18n_public: false,


      pickup_list: false, //*****check this component */

      new_access_card: false,
      new_cards_list: false,
      card_reposition: false,
      pickup_cards: false,

      card_approver_list: false,

      access_request_employee: false,
      access_req_exception: false,
      access_req_contractor: false,
      access_list_records: false,
      access_list_approvers: false,
      otherTemporaryAccess: false,

      incoming_access_requests: false,

      policy_form: false,
      policy_check_management: false,
      policy_list: false,

      policy_approver_list: false,

      all_request: false,

      saa_delegate:false,
      //self verification

      myAuthorisedAccesses: false,
      myQualifications: false

    }

  }
  ngOnInit() {
    this.navbarModules();
    this.Terms();
  }

  mobileNavbarselection(number){
    if(this.optionMenuMobile==number){
      this.optionMenuMobile=0;
    }else{
      this.optionMenuMobile=number;
    }
  }

  cleanNavSelection(){
    this.navbarMobile = false;
    this.optionMenuMobile=0;

  }



  navbarModules() {
    for(const idmod of JSON.parse(sessionStorage.currentUser).modules) {
      switch(Number(idmod)){
        case 1:
          this.ActiveModule.admin_rol_list = false;
          break;
        case 2:
          this.ActiveModule.admin_types_lists = false;
          break;
        case 3:
          this.ActiveModule.admin_business_units = false;
          break;
        case 4:
          this.ActiveModule.admin_faq_section = false;
          break;
        case 6:
          this.ActiveModule.admin_sites = false;
          break;
        case 11:
          this.ActiveModule.pickup_list = true;
          break;
        case 12:
          this.ActiveModule.new_access_card = true;
          break;
        case 14:
          this.ActiveModule.new_cards_list = true;
          break;
        case 16:
          this.ActiveModule.card_reposition = true;
          break;
        case 17:
          this.ActiveModule.pickup_cards = true;
          break;
        case 18:
          this.ActiveModule.card_approver_list = true;
          break;
        case 20:
          this.ActiveModule.access_request_employee = true;
          break;
        case 22:
          this.ActiveModule.access_req_exception = true;
          break;
        case 23:
          this.ActiveModule.access_req_contractor = true;
          break;
        case 24:
          this.ActiveModule.access_list_records = true;
          break;
        case 26:
          this.ActiveModule.access_list_approvers = true;
          break;
        case 27:
          this.ActiveModule.incoming_access_requests = true;
          break;
        case 30:
          this.ActiveModule.policy_form = true;
          break;
        case 32:
          this.ActiveModule.policy_check_management = true;
          break;
        case 33:
          this.ActiveModule.policy_list = true;
          break;
        case 34:
          this.ActiveModule.policy_approver_list = true;
          break;
        case 35:
          this.ActiveModule.all_request = true;
          break;
        case 36:
          this.ActiveModule.otherTemporaryAccess = true;
          break;
        case 37:
          this.ActiveModule.myAuthorisedAccesses = true;
          break;
        case 39:
          this.ActiveModule.myQualifications = true;
          break;
        case 41:
          this.ActiveModule.admin_i18n_sar = false;
          break;
        case 42:
          this.ActiveModule.admin_i18n_public = false;
          break;
        case 46:
          this.ActiveModule.saa_delegate = true;
          break;
      }
    }
  }

  openSide(drawer: any){
    this.side=!this.side;
    drawer.toggle()

  }
  logout() {
    this.dataApiSar.Logout().subscribe(()=>{
      this.oauthService.logOut();
      sessionStorage.clear();
    }, ()=>{
      this.oauthService.logOut();
      sessionStorage.clear();
    });

  }
  givenName() {
    this.claims = this.oauthService.getIdentityClaims();
    if (!this.claims) {
      return null;
    }
    this.email = this.claims['preferred_username'];
    this.nameTool= this.claims.name;
    this.name = this.email.substring(0,1).toUpperCase();
    this.lastname = this.email.split('.', -1)[1].substring(0,1).toUpperCase();
    this.names= this.name + this.lastname;
  }
  updateLang(lang) {
    sessionStorage.setItem('lang', lang);
    this.selectLang = lang;
    this.dateAdapter.setLocale(String(lang));

    this.spinner.show("translate")
    this.translate.use(String(lang)).subscribe(
      (response)=>{
        this.spinner.hide("translate")
      }
      ,
      ()=>{
        this.spinner.hide("translate")
      });

  }
  //terms
  Terms() {

    this.dataApiH.getTerms()
      .subscribe((data: any) => {
        if (data.hasAgreeed === false) {
          this.openDialog();
        }
        else {
          this.id = data.mdmid,
            this.hasAgreeed = data.hasAgreeed;
        }

      });
  }

  //TERMS
  openDialog() {
    this.dialog.open(ModalTermsComponent, { disableClose: true, panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.dataApiSar.refreshToken().subscribe((data: any) => {
          if (data != undefined || data != null) {
            sessionStorage.setItem('Token', data.SARToken);
            sessionStorage.setItem('RefreshToken', data.RefreshToken);
          }
        }, () => {
        })
      } else {
        this.dataApiSar.Logout().subscribe(() => {
          sessionStorage.clear();
          this.oauthService.logOut();
        }, () => {
          sessionStorage.clear();
          this.oauthService.logOut();
        });
      }
    });
  }


}
